import request from '@/utils/request'

export function getFleetCardVehicles(branchId, size, page, find, branchIdQuery) {
  return request({
    url: `/myboat/fleetcardvehicles/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      branchId: branchIdQuery
    }
  })
}

export function getFleetCardVehicleById(branchId, id) {
  return request({
    url: `/myboat/fleetcardvehicles/id/${branchId}/${id}`,
    method: 'get'
  })
}

export function findFleetCardVehicles(branchId, find) {
  return request({
    url: `/myboat/fleetcardvehicles/list/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function reportingFleetCardVehicles(branchId, dates, dateType) {
  return request({
    url: `/myboat/fleetcardvehicles/reporting/${branchId}`,
    method: 'get',
    params: {
      find: find,
      startDate: dates,
      dateType: dateType
    }
  })
}

export function createFleetCardVehicles(branchId, data) {
  return request({
    url: `/myboat/fleetcardvehicles/create/${branchId}`,
    method: 'post',
    data
  })
}

export function addFleetCardVehicles(branchId, data) {
  return request({
    url: `/myboat/fleetcardvehicles/add/${branchId}`,
    method: 'post',
    data
  })
}

export function duplicateFleetCardVehicles(branchId, id) {
  return request({
    url: `/myboat/fleetcardvehicles/duplicate/${branchId}/${id}`,
    method: 'post'
  })
}

export function updateFleetCardVehicles(branchId, id, data) {
  return request({
    url: `/myboat/fleetcardvehicles/id/${branchId}/${id}`,
    method: 'put',
    data
  })
}

export function activeTickFleetCardVehicles(branchId, id, data) {
  return request({
    url: `/myboat/fleetcardvehicles/activeTick/${branchId}/${id}`,
    method: 'post',
    data
  })
}

export function savePercentageFollowUpFleetCardVehicles(branchId, data) {
  return request({
    url: `/myboat/fleetcardvehicles/savePercentageFollowUp/${branchId}`,
    method: 'post',
    data
  })
}

export function personalExcelFleetCardVehicles(branchId, secondBranchId) {
  return request({
    url: `/myboat/fleetcardvehicles/personalExcel/${branchId}`,
    method: 'get',
    params: {
      branchId: secondBranchId
    },
    responseType: 'blob',
    timeout: 300000
  })
}

export function downloadExcelBFleetCardVehicles(branchId, dates, dateType) {
  return request({
    url: `/myboat/fleetcardvehicles/downloadExcelB/${branchId}`,
    method: 'get',
    params: {
      startDate: dates,
      dateType: dateType
    },
    responseType: 'blob',
    timeout: 300000
  })
}

export function removeFleetCardVehicles(branchId, id) {
  return request({
    url: `/myboat/fleetcardvehicles/id/${branchId}/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/myboat/myboatFleetCardVehicles.js